import React from 'react';

const CrossIcon = (props) => {
  return (
    <img
      alt="Kaplica"
      src="/static/images/icons/tourist_attractions/cross.svg"
      {...props}
    />
  );
};

export default CrossIcon;
